import httpClient, {
  getErrorMessage,
  getResponseData,
} from 'lib/httpClient';
import { useListCRUD } from 'lib/swr-crud';
import { Catalogue } from './types';

const fetchers = {
  create: async () => {},
  read: async (url: string, query?: any) => {
    try {
      // @ts-ignore
      const response = await httpClient({
        method: 'GET',
        url,
        query,
      });

      return getResponseData(response);
    } catch (error) {
      throw getErrorMessage(error);
    }
  },
};

const useCatalogues = ({
  page = 1,
  sizePerPage = 30,
}: {
  page?: number;
  sizePerPage?: number;
} = {}) => {
  const url = '/catalogues';
  const { data, error, isLoading } = useListCRUD(url, 'id', {
    fetchers,
    query: {
      page,
      per_page: sizePerPage,
    },
  });

  const catalogues: Array<Catalogue> = data?.data ?? [];
  const total: number = data?.meta?.total ?? 0;

  return { catalogues, total, error, isLoading };
};

export default useCatalogues;
